import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { MentoringReportsModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-data-model';
import { MentoringReportsListingModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-grid-model';
import { MentoringReportsGridMetaModel } from 'common/models/page-models/reports/mentoring-reports/mentoring-grid-meta-model';
import { MentoringReportsDataService } from 'common/services/data-services/admin/reports/mentoring-reports.service';


@Injectable({
    providedIn: 'root'
})
export class MentoringReportsWidgetService extends GridWidgetService<MentoringReportsModel, MentoringReportsListingModel> {
    constructor(protected override  ds: MentoringReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new MentoringReportsGridMetaModel().getMetaModel();
        return meta;
    }

     override prepareMetaModel(dataModel: MentoringReportsListingModel, metaModel: MentoringReportsGridMetaModel, routeData: WidgetModel): Promise<MentoringReportsGridMetaModel> {
        return new Promise<MentoringReportsGridMetaModel>((resolve, reject) => {
            
            this.batchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBatch.options = data.details;
            });
            this.branchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
            });
            resolve(metaModel);
        });
    }

}